import { render, staticRenderFns } from "./Wish.edit.vue?vue&type=template&id=481c38a1&scoped=true&"
import script from "./Wish.edit.vue?vue&type=script&lang=js&"
export * from "./Wish.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c38a1",
  null
  
)

export default component.exports